import script from "./shop-style-1.vue?vue&type=script&setup=true&lang=js"
export * from "./shop-style-1.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__